'use client';
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "NavigatorTypeContext", {
    enumerable: true,
    get: function() {
        return NavigatorTypeContext;
    }
});
function _react() {
    const data = require("react");
    _react = function() {
        return data;
    };
    return data;
}
const NavigatorTypeContext = /*#__PURE__*/ (0, _react().createContext)(undefined);

//# sourceMappingURL=NavigatorTypeContext.js.map
